@import "../../global/gx-ide-mixins.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-areas:
    "aside main"
    "footer footer";
  grid-template-rows: 1fr max-content;
  grid-template-columns: 240px 1fr;
}

:host(.display-header-type) {
  grid-template-areas:
    "header header"
    "aside main"
    "footer footer";

  grid-template-rows: max-content 1fr max-content;
  grid-template-columns: 240px 1fr;
}

.section {
  display: contents;
}

// - - - - - - - - - - - - -
// Header
// - - - - - - - - - - - - -

.header {
  grid-area: header;
  display: grid;
  grid-template-columns: 1fr max-content;

  &__description {
    display: grid;
    gap: var(--spacing-gap-m);

    &-p {
      max-inline-size: 460px;
    }
  }
  &__actions {
    flex-shrink: 0;
  }
}

// - - - - - - - - - - - - -
// Aside & Main
// - - - - - - - - - - - - -

.aside {
  grid-area: aside;
  overflow: auto;
  border-inline-end: var(--section-common-border);
  display: grid;
  grid-template-rows: max-content 1fr;
}

.main {
  grid-area: main;
  overflow: auto;
}

// - - - - - - - - - - - - -
// Footer
// - - - - - - - - - - - - -

.footer {
  grid-area: footer;
  justify-content: flex-start;
}

// - - - - - - - - - - - - - - - - - - -
// Tree view status custom status "icon"
// - - - - - - - - - - - - - - - - - - -
.tree-view::part(item__action tree-view-item--success),
.tree-view::part(item__action tree-view-item--warning),
.tree-view::part(item__action tree-view-item--error) {
  // WA custom solution for two icons
  // Because this is a one level tree, there is no risk of
  // breaking the layout with a custom padding.
  padding-inline-start: 24px;
}

.tree-view::part(item__action tree-view-item--success) {
  background: var(--icon__states_pill-filled_success--enabled) no-repeat;
  background-position-y: center;
}
.tree-view::part(item__action tree-view-item--warning) {
  background: var(--icon__states_pill-filled_warning--enabled) no-repeat;
  background-position-y: center;
}
.tree-view::part(item__action tree-view-item--error) {
  background: var(--icon__states_pill-filled_error--enabled) no-repeat;
  background-position-y: center;
}
